import React, { useState } from 'react';
import { Box, Flex, Text, Input, InputGroup, InputRightElement, IconButton, Button, Link, SimpleGrid, VStack, HStack, Divider } from '@chakra-ui/react';
import { Header } from '../components/Header';
import { Eye, EyeOff } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function RegisterPage() {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [company, setCompany] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const navigate = useNavigate();
  const allFilled = firstName.trim() !== '' && lastName.trim() !== '' && company.trim() !== '' && email.trim() !== '' && password !== '' && confirmPassword !== '';
  const inputStyles = {
    variant: 'unstyled',
    fontSize: 'md',
    color: 'gray.600',
    _placeholder: {
      color: 'gray.500'
    },
    pb: 2,
    _focus: {
      bg: '#FFF59D',
      border: '1px solid #D4C85C',
      borderRadius: 'sm',
      px: 2,
      pt: 2
    }
  };
  const wrapperStyles = {
    mb: 4,
    borderBottom: '1px solid #ccc'
  };
  return <Box w="100vw" h="100vh" bg="white" overflow="auto" data-id="element-344">
      <Header data-id="element-345" />

      <Box pt="64px" px={6} py={6} data-id="element-346">
        <Box border="2px solid #006666" borderRadius="md" bg="white" maxW="900px" p={6} className="ml-[37px] mr-[37px] mt-[60px] mb-[60px]" data-id="element-347">
          <Text fontSize="2xl" fontWeight="bold" color="black" mb={1} data-id="element-348">
            Sign Up
          </Text>

          <Flex align="center" gap={1} mb={6} data-id="element-349">
            <Text fontSize="md" color="black" data-id="element-350">
              Already have an account?
            </Text>
            <Link color="blue.600" fontWeight="bold" fontSize="md" textTransform="uppercase" letterSpacing="0.03em" onClick={() => navigate('/login')} _hover={{
            textDecoration: 'underline'
          }} data-id="element-351">
              SIGN IN
            </Link>
          </Flex>

          <SimpleGrid columns={{
          base: 1,
          md: 2
        }} spacing={10} mb={6} data-id="element-352">
            {/* Left Column */}
            <Box data-id="element-353">
              <Box {...wrapperStyles} data-id="element-354">
                <Input {...inputStyles} placeholder="First Name" value={firstName} onChange={e => setFirstName(e.target.value)} data-id="element-355" />
              </Box>
              <Box {...wrapperStyles} data-id="element-356">
                <Input {...inputStyles} placeholder="Last Name" value={lastName} onChange={e => setLastName(e.target.value)} data-id="element-357" />
              </Box>
              <Box {...wrapperStyles} data-id="element-358">
                <Input {...inputStyles} placeholder="Company" value={company} onChange={e => setCompany(e.target.value)} data-id="element-359" />
              </Box>
              <Box {...wrapperStyles} data-id="element-360">
                <Input {...inputStyles} placeholder="Email" type="email" value={email} onChange={e => setEmail(e.target.value)} data-id="element-361" />
              </Box>
              <Text color="red.500" fontSize="sm" mt={4} data-id="element-362">
                (All fields are required.)
              </Text>
            </Box>

            {/* Right Column */}
            <Box data-id="element-363">
              <Box {...wrapperStyles} data-id="element-364">
                <InputGroup data-id="element-365">
                  <Input {...inputStyles} placeholder="Password" type={showPassword ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} data-id="element-366" />
                  <InputRightElement data-id="element-367">
                    <IconButton aria-label={showPassword ? 'Hide password' : 'Show password'} icon={showPassword ? <EyeOff size={18} data-id="element-369" /> : <Eye size={18} data-id="element-370" />} variant="ghost" size="sm" color="gray.500" onClick={() => setShowPassword(!showPassword)} _hover={{
                    bg: 'transparent'
                  }} data-id="element-368" />
                  </InputRightElement>
                </InputGroup>
              </Box>
              <Box {...wrapperStyles} data-id="element-371">
                <InputGroup data-id="element-372">
                  <Input {...inputStyles} placeholder="Confirm Password" type={showConfirmPassword ? 'text' : 'password'} value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} data-id="element-373" />
                  <InputRightElement data-id="element-374">
                    <IconButton aria-label={showConfirmPassword ? 'Hide password' : 'Show password'} icon={showConfirmPassword ? <EyeOff size={18} data-id="element-376" /> : <Eye size={18} data-id="element-377" />} variant="ghost" size="sm" color="gray.500" onClick={() => setShowConfirmPassword(!showConfirmPassword)} _hover={{
                    bg: 'transparent'
                  }} data-id="element-375" />
                  </InputRightElement>
                </InputGroup>
              </Box>

              <Box mt={4} data-id="element-378">
                <Text fontSize="xs" fontWeight="bold" color="black" mb={1} data-id="element-379">
                  MINIMUM REQUIREMENTS
                </Text>
                <VStack align="start" spacing={0} data-id="element-380">
                  {['Begin with a lowercase letter', 'Contain 10-64 characters', 'Contain upper & lower case letters', 'Contain at least 1 number', 'Contain at least 1 symbol (! & # $ % @ ^ *)', 'Not end with a number or symbol', 'Passwords match'].map((req, idx) => <HStack key={idx} spacing={1.5} py={0.5} data-id="element-381">
                      <Box w="11px" h="11px" minW="11px" borderRadius="full" border="1px solid" borderColor="red.500" position="relative" display="flex" alignItems="center" justifyContent="center" data-id="element-382">
                        <Box w="9px" h="1px" bg="red.500" transform="rotate(-45deg)" position="absolute" data-id="element-383" />
                      </Box>
                      <Text fontSize="xs" color="gray.700" data-id="element-384">
                        {req}
                      </Text>
                    </HStack>)}
                </VStack>
              </Box>
            </Box>
          </SimpleGrid>

          <Divider borderColor="gray.200" mb={6} data-id="element-385" />

          <Flex justify="center" gap={4} mb={6} data-id="element-386">
            <Button bg="#E53E3E" color="white" _hover={{
            bg: '#C53030'
          }} px={8} borderRadius="md" fontWeight="semibold" onClick={() => navigate('/login')} data-id="element-387">
              Cancel
            </Button>
            <Button bg="#0d6dfc" color="white" _hover={{
            bg: '#0b5fd9'
          }} _active={{
            bg: '#0a52be'
          }} px={12} borderRadius="md" fontWeight="semibold" isDisabled={!allFilled} opacity={allFilled ? 1 : 0.6} data-id="element-388">
              Register
            </Button>
          </Flex>

          <Box bg="#D5E8D4" border="1px solid #82B366" p={4} borderRadius="sm" data-id="element-389">
            <Text fontSize="md" color="black" mb={4} data-id="element-390">
              <strong data-id="element-391">IMPORTANT:</strong> 80% of all security breaches are due
              to bad passwords. The password requirements included here should
              be considered the bare minimum. You should create a password that
              is much more secure than these requirements. Ultimately, YOU ARE
              RESPONSIBLE for the security of your login account.
            </Text>
            <Text fontSize="md" color="black" data-id="element-392">
              Here are two articles{' '}
              <Link href="https://cybernews.com/best-password-managers/how-to-create-a-strong-password/" isExternal color="blue.600" fontWeight="bold" _hover={{
              textDecoration: 'underline'
            }} data-id="element-393">
                HERE
              </Link>{' '}
              and{' '}
              <Link href="https://www.inmotionhosting.com/blog/how-strong-is-my-password/" isExternal color="blue.600" fontWeight="bold" _hover={{
              textDecoration: 'underline'
            }} data-id="element-394">
                HERE
              </Link>{' '}
              with tips on creating a good password.
            </Text>
          </Box>
        </Box>
      </Box>
    </Box>;
}